import { render, staticRenderFns } from "./cardRight.vue?vue&type=template&id=4d0a67c6&scoped=true&"
import script from "./cardRight.vue?vue&type=script&lang=js&"
export * from "./cardRight.vue?vue&type=script&lang=js&"
import style0 from "./cardRight.vue?vue&type=style&index=0&id=4d0a67c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0a67c6",
  null
  
)

export default component.exports